module.exports = __webpack_public_path__ + "static/img/bg5.8646737a.png";